import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=5f329308&scoped=true&"
import script from "./Diff.vue?vue&type=script&lang=js&"
export * from "./Diff.vue?vue&type=script&lang=js&"
import style0 from "./Diff.vue?vue&type=style&index=0&id=5f329308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f329308",
  null
  
)

export default component.exports